import * as React from 'react';
import { IIconProps } from '@cian/ui-kit-design-tokens/icons';

export const IconCianMagazine20 = ({ color }: IIconProps) => {
  const currentColor = color ? `var(--${color})` : 'currentColor';

  return (
    // eslint-disable-next-line react/forbid-elements
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 6.2513C10 6.2513 6.66667 4.16797 2.5 4.16797V15.1488C6.66667 15.1488 10 17.5013 10 17.5013C10 17.5013 13.3333 15.1488 17.5 15.1488V4.16797C16.3 4.16797 15.1692 4.34047 14.1667 4.58714"
        stroke={currentColor}
        strokeWidth="1.66667"
      />
      <path
        d="M14.1667 12.5013V1.66797C14.1667 1.66797 10.8333 2.5013 10 5.5113V17.5013C10.8333 13.7513 14.1667 12.5013 14.1667 12.5013Z"
        stroke={currentColor}
        strokeWidth="1.66667"
        strokeLinecap="round"
      />
    </svg>
  );
};
